module.exports = __webpack_public_path__ + "img/ac2.390ce024.png";